export default "__VITE_ASSET__BOJwZrJr__"